<template>
    <div class="color-plane">
        <div class="plane">
            
            <div class="plane-list">
                <template v-for=" (item,pk) in planes">
                    
                    <button :class="{'waite-btn':activePlane.id !== item.id }" class="btn ml-8" :key="pk"
                            @click="changePlane(item)">{{ item.name }}
                    </button>
                
                </template>
            </div>
            <div class="header-btn-list">
                <button @click="activeAddModal" class="btn waite-btn edit-btn">添加模板</button>
                <template v-if="activePlane && activePlane.app_id">
                    <button class="btn ml-8" @click="editPlane">修改模板名称</button>
                    <button class="btn btn-danger ml-8 outline" @click="deletePlane">删除模板</button>
                </template>
            </div>
        
        </div>
        <div class="plane-content" v-if="planes && planes.length"
             :class="{'plane-enabled': activePlane.id === defaultPlane.id }">
            
            <div class="plane-enabled-img"></div>
            
            <div class="plane-switch">
                
                <div class="flex flex-left-center"  v-if="activePlane">
                    
                    <span class="mr-4">模板启用</span>
                    <a-switch :disabled=" isDisabled " @change="changeDefault"
                              :checked="activePlane.id === defaultPlane.id"/>
                
                </div>
                <a class="preview-btn" @click="handleShowMobileLocation">📱查看手机端对应位置</a>
            </div>
            
            <div class="plane-items">
                <slot></slot>
            </div>
        
        </div>
        
        <at-modal v-model="showColorModal" title="添加模板" @ok="confirmColorPlane">
            
            <p>请输入模板名称</p>
            
            <at-input class="full-with" v-model="params.name"/>
        
        </at-modal>
    
    </div>
</template>

<script>
import AtModal from "@/components/AtModal.vue";
import AtInput from "@/components/AtInput.vue";

export default {
    name: "ProfilePlane",
    components: {AtInput, AtModal},
    props: {
        planes: {
            type: Array,
            default: () => []
        },
        activeId: Number,
    },
    data() {
        return {
            showColorModal: false,
            params: {
                name: "",
                id: "",
            }
        }
    },
    computed: {
        activePlane() {
            return this.planes.find(item => item.id === this.activeId) ||
                this.planes.find(item => item.is_default) ||
                this.planes.find(item => item.app_id === 0)
        },
        defaultPlane() {
            return this.planes.find(item => item.is_default) ||
                this.planes.find(item => item.app_id === 0)
        },
        isDisabled() {
            return this.activePlane.id === this.defaultPlane.id
        }
    },
    watch: {
        planes: {
            handler() {
                if (this.activePlane !== this.activeId) {
                    this.$emit('planeChanged', this.activePlane)
                }
            },
            deep: true
        },
    },
    methods: {
        changePlane(item) {
            if (this.activePlane.id === item.id) return
            this.$emit('planeChanged', item)
        },
        editPlane() {
            this.params.name = this.activePlane.name
            this.params.id = this.activePlane.id
            
            this.showColorModal = true
        },
        deletePlane() {
            this.$emit('deletePlane', this.activePlane.id)
        },
        activeAddModal() {
            this.params.name = ''
            this.params.id = null
            
            this.showColorModal = true
        },
        changeDefault() {
            this.$emit('changeDefault', this.activePlane.id)
        },
        handleShowMobileLocation() {
            this.$emit('showMobileLocation', this.activePlane.id)
        },
        confirmColorPlane() {
            this.$emit('syncPlane', this.params, () => {
                this.showColorModal = false
            });
        },
    }
}
</script>

<style scoped lang="less">
.plane-enabled {
    .plane-enabled-img {
        display: block;
    }
    
    .plane-switch {
        padding-left: 114px;
    }
}

.plane-enabled-img {
    width: 114px;
    height: 114px;
    background-image: url("/assets/icons/profile-plane-brage.png");
    background-size: contain;
    position: absolute;
    left: 0;
    top: 0;
    display: none;
    z-index: 2;
    pointer-events: none;
}

.plane {
    padding: 16px 24px;
    border: 1px solid #EEEEEE;
    overflow: hidden;
}

.plane-content {
    padding: 24px;
    border: 1px solid #EEEEEE;
    border-top: 0;
    min-height: 300px;
    position: relative;
}

.plane-switch {
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    transition: all .3s;
}

.waite-btn {
    border: 1px solid #EEEEEE;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    background-color: #FFFFFF;
    transition: all .3s;
    
    &:hover {
        color: #333333;
        border-color: #333333;
        border-radius: 4px;
    }
}

.header-btn-list {
    width: 355px;
    float: right;
    display: flex;
    justify-content: flex-end;
}

.plane-list {
    float: left;
}

.plane-items {
    margin-top: 24px;
}

@media screen and (max-width: 1300px) {
    .header-btn-list {
        margin-top: 12px;
    }
}

.preview-btn {
    color: #FBB03B;
    position: absolute;
    right: 24px;
    top: 26px;
}

</style>